import { observer } from 'mobx-react-lite';
import * as React from 'react';

export interface AttachmentDocInfoBaseProps {
    firstLineTitle?: string;
    firstLineText: string;
    secondLineTitle?: string;
    secondLineText?: string;
    firstLineStyle?: string;
    secondLineStyle?: string;
    isShortDocView: boolean;
    highlightAttachmentName?: (ref: HTMLDivElement) => void;
}

const styles = require('./AttachmentDocInfoViewBase.scss');
const classNames = require('classnames/bind').bind(styles);

const AttachmentDocInfoViewBase = observer(function AttachmentDocInfoViewBase(
    props: AttachmentDocInfoBaseProps
) {
    const {
        firstLineTitle,
        firstLineText,
        secondLineTitle,
        secondLineText,
        highlightAttachmentName,
    } = props;
    if (props.isShortDocView) {
        return (
            <div
                className={classNames(
                    styles.firstLineCommonStyle,
                    props.firstLineStyle,
                    styles.textOverFlow
                )}
                title={firstLineTitle}
                ref={highlightAttachmentName}>
                {firstLineText}
            </div>
        );
    }

    return (
        <>
            <div
                className={classNames(
                    styles.firstLineCommonStyle,
                    props.firstLineStyle,
                    styles.textOverFlow
                )}
                title={firstLineTitle}>
                {firstLineText}
            </div>
            <div
                title={secondLineTitle}
                className={classNames(
                    styles.secondLineCommonStyle,
                    props.secondLineStyle,
                    styles.textOverFlow
                )}>
                {secondLineText}
            </div>
        </>
    );
});
export default AttachmentDocInfoViewBase;
